import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import Comments from '../components/Comments';
import { DrinkImage } from '../components/GameImages';
import '../css.css';

const DrinkPage = () => {
    const [drinkData, setDrinkData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/api/drink');
                if (!response.ok) throw new Error('Network response was not ok');
                
                const data = await response.json();
                setDrinkData(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const renderTable = () => {
        if (drinkData.length === 0) return null;

        // 컬럼 매핑 정의 (filename은 이미지용으로만 사용하고 헤더에서 제외)
        const columnMapping = {
            name: '이름',
            shop: '판매위치',
            map: '판매수역',
            exp_bonus: '경험치 보너스%',
            exp_duration: '지속시간',
            purchase_qty: '1회 구매수량',
            price_100: '가격(100%)',
            price_90: '가격(80%올벅)',
            price_per1: '1병당 가격'
        };

        // 표시할 컬럼들 (id와 filename 제외)
        const displayColumns = Object.keys(columnMapping);

        return (
            <table className="oil-table">
                <thead>
                    <tr>
                        <th>사진</th>
                        {displayColumns.map(column => (
                            <th key={column}>{columnMapping[column]}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {drinkData.map((row, index) => (
                        <tr key={row.id || index}>
                            <td style={{ textAlign: 'center' }}>
                                {row.filename && (
                                    <DrinkImage 
                                        filename={row.filename}
                                        alt={row.name || row.filename}
                                        className="drink-table-image"
                                        onError={() => {
                                            console.warn('Failed to load drink image:', row.filename);
                                        }}
                                    />
                                )}
                            </td>
                            {displayColumns.map(column => (
                                <td key={column}>{row[column]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <>
            <h1 className="page-title">술 정보</h1>
            <div>
                {loading ? (
                    <div className="spinner-container">
                        <LoadingSpinner
                            height={80}
                            width={80}
                            color="#4fa94d"
                            visible={true}
                        />
                    </div>
                ) : (
                    <div className="page-content">
                        {renderTable()}
                    </div>
                )}
                
                <Comments pageName="drink" />
            </div>
        </>
    );
};

export default DrinkPage;
